import { Button } from '@platform/design-system';
import { Plus } from 'lucide-react';
import { usePageContext } from '../../usePageContext.ts';
import styles from './Widgets.module.css';

const ICON_SIZE = 20;

export type EditBarProps = {
  full: boolean;
  saving: boolean;
  onAdd: () => void;
  onCancel: () => void;
  onSaveAs: () => void;
  onSave: () => void;
};

export const EditBar = ({ full, saving, onAdd, onCancel, onSaveAs, onSave }: EditBarProps) => {
  const { t } = usePageContext();
  return (
    <div className={styles['editBar']} role="toolbar" aria-label={t('dashboard.widgets.editing')}>
      <p className={styles['editHint']}>{t('dashboard.widgets.editHint')}</p>
      <Button
        variant="outline"
        icon={<Plus size={ICON_SIZE} aria-hidden="true" />}
        disabled={full}
        onClick={onAdd}
      >
        {t('dashboard.widgets.add')}
      </Button>
      <Button variant="ghost" onClick={onCancel}>
        {t('common.cancel')}
      </Button>
      <Button variant="outline" disabled={saving} onClick={onSaveAs}>
        {t('dashboard.views.saveAs')}
      </Button>
      <Button disabled={saving} aria-busy={saving} onClick={onSave}>
        {t('common.save')}
      </Button>
    </div>
  );
};
